module.exports = __webpack_public_path__ + "static/media/rideAvatar.1b3ba528.svg";